import axios from 'axios'

export default {
  getHotWords: (config = {}) => axios.get('https://online.xueersi.com/mall/getHotWord', config),
  getQuerySug: ({ keyword = '', xesid = '', devid = '', page_grade = '' }, config = {}) =>
    axios.get(`/getQuerySug`, {
      params: { keyword, xesid, devid, page_grade },
      ...config
    })
}



// WEBPACK FOOTER //
// ./src/networks/api/Search/index.js